import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AgentCreateRequest } from "../../shared/types/agent";
import { agentApi } from "../services/agentApi";
import { AgentForm } from "../components/AgentSettings/AgentForm";

export const AgentCreateView: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleCreateAgent = async (data: AgentCreateRequest | AgentUpdateRequest) => {
    try {
      setLoading(true);
      setError(null);
      const response = await agentApi.create(data);
      if (response.success && response.data) {
        // Navigate back to agent list
        navigate('/app/settings/agents');
      } else {
        setError(response.error || 'Failed to create agent');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to create agent');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/app/settings/agents');
  };

  return (
    <div className="h-full overflow-hidden">
      <div className="h-full flex flex-col">
        {/* Header */}
        <div className="flex-shrink-0 p-6 border-b border-border-primary">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-xl font-semibold text-white">Create New Agent</h2>
              <p className="text-gray-400 mt-1">Configure a new AI agent for your workflows</p>
            </div>
            <button
              onClick={handleCancel}
              className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors flex items-center gap-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
              Cancel
            </button>
          </div>
        </div>

        {/* Form Content */}
        <div className="flex-1 overflow-y-auto p-6">
          <div className="max-w-4xl mx-auto">
            {error && (
              <div className="mb-6 p-4 bg-red-500/20 border border-red-500/50 rounded-lg text-red-200">
                {error}
              </div>
            )}
            
            <AgentForm
              onSubmit={handleCreateAgent}
              onCancel={handleCancel}
              loading={loading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
